// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// TODO. Inherit from DataCacheBusinessObject.
import { ErrorInformationStorage } from '../ErrorInformationStorage';
import { AccountType } from '@shared/utils/Account/AccountType';
import { AccountAdditionalInfoItem } from '@shared/utils/Account/AdditionalInfoItem';
import { MathUtils } from '@shared/utils/MathUtils';
import { InstrumentTypes } from '@shared/utils/Instruments/InstrumentTypes';
export class AssetBalance {
    constructor(account, isEmpty) {
        this.Asset = null;
        this.account = account;
        this.FDataCache = account.DataCache;
        isEmpty = isEmpty || false;
        this.IsEmpty = isEmpty;
        this.assetBalanceData = isEmpty ? AssetBalanceData.Empty : new AssetBalanceData();
    }
    RecreateData() {
        this.assetBalanceData = new AssetBalanceData();
        this.IsEmpty = false;
    }
    FillByMessage(mess) {
        const assetBalanceData = this.assetBalanceData;
        if (mess.Balance !== null) {
            assetBalanceData.balance = mess.Balance;
        }
        if (mess.BlockedSum !== null) {
            assetBalanceData.blockedSum = mess.BlockedSum;
        }
        if (mess.CashBalance !== null) {
            assetBalanceData.cashBalance = mess.CashBalance;
        }
        if (mess.BeginBalance !== null) {
            assetBalanceData.beginBalance = mess.BeginBalance;
        }
        if (mess.RealizedPnl !== null) {
            assetBalanceData.realizedPnl = mess.RealizedPnl;
        }
        // nicky fix (по согласованию с сашей и женей)
        // сервером присылается + если с меня снимают деньги, + если приплюсовывают.
        if (mess.TodayFees !== null) {
            assetBalanceData.todayFees = -mess.TodayFees;
        }
        if (mess.TodayTurnover !== null) {
            assetBalanceData.todayTurnover = mess.TodayTurnover;
        }
        if (mess.BlockedForOrders !== null) {
            assetBalanceData.blockedForOrders = mess.BlockedForOrders;
        }
        // if (mess.LockedForPAMM !== null)
        //     assetBalanceData.blockedForPAMM = mess.LockedForPAMM
        if (mess.ReservedBalance !== null) {
            assetBalanceData.reservedBalance = mess.ReservedBalance;
        }
        if (mess.CreditValue !== null) {
            assetBalanceData.creditValue = mess.CreditValue;
        }
        if (mess.UsedMargin !== null) {
            assetBalanceData.minMargin = mess.UsedMargin;
        }
        if (mess.AvailableMargin !== null) {
            assetBalanceData.availableMargin = mess.AvailableMargin;
        }
        if (mess.AvailableFunds !== null) {
            assetBalanceData.availableFunds = mess.AvailableFunds;
        }
        if (mess.BlockedForStocks !== null) {
            assetBalanceData.blockedForStocks = mess.BlockedForStocks;
        }
        if (mess.MaintanceMargin !== null) {
            assetBalanceData.maintanceMargin = mess.MaintanceMargin;
        }
        if (mess.MarginDeficiency !== null) {
            assetBalanceData.marginDeficiency = mess.MarginDeficiency;
        }
        if (mess.MarginSurplus !== null) {
            assetBalanceData.marginSurplus = mess.MarginSurplus;
        }
        if (mess.InitialMarginWithoutWaived !== null) {
            assetBalanceData.InitialMarginWithoutWaived = mess.InitialMarginWithoutWaived;
        }
        if (mess.TodayTrades !== null) {
            assetBalanceData.todayTrades = mess.TodayTrades;
        }
        if (mess.TodayVolume !== null) {
            assetBalanceData.todayVolume = mess.TodayVolume;
        }
        if (mess.TodayRebates !== null) {
            assetBalanceData.todayRebates = mess.TodayRebates;
        }
        if (mess.TodaySwaps !== null) {
            assetBalanceData.todaySwaps = mess.TodaySwaps;
        }
        if (mess.UnsettledLoss !== null) {
            assetBalanceData.unsettledLoss = mess.UnsettledLoss;
        }
        if (mess.UnsettledProfit !== null) {
            assetBalanceData.unsettledProfit = mess.UnsettledProfit;
        }
        if (mess.CurrentDailyLoss !== null) {
            assetBalanceData.currentDailyLoss = mess.CurrentDailyLoss;
        }
        if (mess.CurrentDailyProfit !== null) {
            assetBalanceData.currentDailyProfit = mess.CurrentDailyProfit;
        }
        if (mess.CurrentWeeklyLoss !== null) {
            assetBalanceData.currentWeeklyLoss = mess.CurrentWeeklyLoss;
        }
        if (mess.TrailingDrawdownLevel !== null) {
            assetBalanceData.trailingDrawdownLevel = mess.TrailingDrawdownLevel;
        }
        if (mess.StockOrdersReq !== null) {
            assetBalanceData.stockOrdersReq = mess.StockOrdersReq;
        }
        if (mess.UsedUnsettledNegativePremium !== null) {
            assetBalanceData.UsedUnsettledNegativePremium = mess.UsedUnsettledNegativePremium;
        }
        if (mess.UnusedUnsettledNegativePremium !== null) {
            assetBalanceData.UnusedUnsettledNegativePremium = mess.UnusedUnsettledNegativePremium;
        }
        if (mess.UnsettledPositivePremium !== null) {
            assetBalanceData.UnsettledPositivePremium = mess.UnsettledPositivePremium;
        }
        if (mess.UnsettledPremiumFromOpenSell !== null) {
            assetBalanceData.UnsettledPremiumFromOpenSell = mess.UnsettledPremiumFromOpenSell;
        }
        if (mess.UsedPremiumFromOpenSell !== null) {
            assetBalanceData.UsedPremiumFromOpenSell = mess.UsedPremiumFromOpenSell;
        }
        if (mess.UnusedPremiumFromOpenSell !== null) {
            assetBalanceData.UnusedPremiumFromOpenSell = mess.UnusedPremiumFromOpenSell;
        }
        if (mess.UsedUnsettledNegativeCashForStocks !== null) {
            assetBalanceData.UsedUnsettledNegativeCashForStocks = mess.UsedUnsettledNegativeCashForStocks;
        }
        if (mess.UnusedUnsettledNegativeCashForStocks !== null) {
            assetBalanceData.UnusedUnsettledNegativeCashForStocks = mess.UnusedUnsettledNegativeCashForStocks;
        }
        if (mess.UnsettledPositiveCashForStocks !== null) {
            assetBalanceData.UnsettledPositiveCashForStocks = mess.UnsettledPositiveCashForStocks;
        }
        if (mess.StocksLiquidity !== null) {
            assetBalanceData.StocksLiquidity = mess.StocksLiquidity;
        }
        if (mess.OptionPremiumReq !== null) {
            assetBalanceData.OptionPremiumReq = mess.OptionPremiumReq;
        }
        if (mess.UnsettledLossAvailableForWithdrawal !== null) {
            assetBalanceData.UnsettledLossAvailableForWithdrawal = mess.UnsettledLossAvailableForWithdrawal;
        }
        if (mess.WithdrawableCashForStocks !== null) {
            assetBalanceData.WithdrawableCashForStocks = mess.WithdrawableCashForStocks;
        }
        if (mess.WithdrawableUnsettledPnL !== null) {
            assetBalanceData.WithdrawableUnsettledPnL = mess.WithdrawableUnsettledPnL;
        }
        if (mess.UnsettledCollateral !== null) {
            assetBalanceData.UnsettledCollateral = mess.UnsettledCollateral;
        }
        if (mess.WithdrawableUnsettledCollateral !== null) {
            assetBalanceData.WithdrawableUnsettledCollateral = mess.WithdrawableUnsettledCollateral;
        }
        if (mess.Collateral !== null) {
            assetBalanceData.Collateral = mess.Collateral;
        }
        if (mess.UnusedSettledCashForStocks !== null) {
            assetBalanceData.UnusedSettledCashForStocks = mess.UnusedSettledCashForStocks;
        }
        if (mess.UnusedSettledCollateral !== null) {
            assetBalanceData.UnusedSettledCollateral = mess.UnusedSettledCollateral;
        }
        if (mess.UnsettledDeposit !== null) {
            assetBalanceData.unsettledDeposit = mess.UnsettledDeposit;
        }
        if (mess.UnusedIntradayInitialMargin !== null) {
            assetBalanceData.UnusedIntradayInitialMargin = mess.UnusedIntradayInitialMargin;
        }
        if (mess.UsedOvernightInitialMarginForIntraday !== null) {
            assetBalanceData.UsedOvernightInitialMarginForIntraday = mess.UsedOvernightInitialMarginForIntraday;
        }
        if (mess.AccruedDividends !== null) {
            assetBalanceData.AccruedDividends = mess.AccruedDividends;
        }
        if (mess.WithdrawableOptionsPremium !== null) {
            assetBalanceData.WithdrawableOptionsPremium = mess.WithdrawableOptionsPremium;
        }
        if (mess.WarningMarginRequirement !== null) {
            assetBalanceData.warningMarginRequirement = mess.WarningMarginRequirement;
        }
        if (mess.MarginBeforeWarning !== null) {
            assetBalanceData.marginBeforeWarning = mess.MarginBeforeWarning;
        }
        if (mess.WithdrawalAvailable !== null) {
            assetBalanceData.WithdrawalAvailable = mess.WithdrawalAvailable;
        }
        if (mess.MaintenanceMarginReqPercent != null) {
            assetBalanceData.MaintenanceMarginReqPercent = mess.MaintenanceMarginReqPercent;
        }
        if (mess.InitialMarginReqPercent != null) {
            assetBalanceData.InitialMarginReqPercent = mess.InitialMarginReqPercent;
        }
        if (mess.WarningMarginReqPercent != null) {
            assetBalanceData.WarningMarginReqPercent = mess.WarningMarginReqPercent;
        }
        if (mess.StopOutValue != null) {
            assetBalanceData.StopOutValue = mess.StopOutValue;
        }
        if (mess.EODTrailingDrawdownLevel != null) {
            assetBalanceData.EODTrailingDrawdownLevel = mess.EODTrailingDrawdownLevel;
        }
        // #120451
        if (mess.CalculatedRelativeDailyLossLimit != null) {
            assetBalanceData.CalculatedRelativeDailyLossLimit = mess.CalculatedRelativeDailyLossLimit;
        }
        if (mess.RelativeOfRelativeDailyLossLimit != null) {
            assetBalanceData.RelativeOfRelativeDailyLossLimit = mess.RelativeOfRelativeDailyLossLimit;
        }
        if (mess.TotalPositionsValue != null) {
            assetBalanceData.TotalPositionsValue = mess.TotalPositionsValue;
        }
        if (mess.AvailableCash != null) {
            assetBalanceData.AvailableCash = mess.AvailableCash;
        }
        let AssetAdditionalInfoUpdated = false;
        if (mess.AssetAdditionalInfo != null) {
            for (const itemKey in mess.AssetAdditionalInfo) {
                if (!mess.AssetAdditionalInfo.hasOwnProperty(itemKey)) {
                    continue;
                }
                const itemValue = mess.AssetAdditionalInfo[itemKey];
                if (assetBalanceData.AssetAdditionalInfo[itemKey]) {
                    assetBalanceData.AssetAdditionalInfo[itemKey].Update(itemValue);
                }
                else {
                    const newItem = new AccountAdditionalInfoItem();
                    newItem.Update(itemValue);
                    assetBalanceData.AssetAdditionalInfo[itemKey] = newItem;
                    AssetAdditionalInfoUpdated = true;
                }
            }
        }
        if (!isNullOrUndefined(mess.BuyingPowerAvailableFunds)) {
            assetBalanceData.BuyingPowerAvailableFunds = mess.BuyingPowerAvailableFunds;
        } // #106952
        if (!isNullOrUndefined(mess.blockedForFixedIncome)) {
            assetBalanceData.blockedForFixedIncome = mess.blockedForFixedIncome;
        }
        if (!isNullOrUndefined(mess.fixedIncomeOrdersReq)) {
            assetBalanceData.fixedIncomeOrdersReq = mess.fixedIncomeOrdersReq;
        }
        if (!isNullOrUndefined(mess.unusedUnsettledNegativeCashForFixedIncome)) {
            assetBalanceData.unusedUnsettledNegativeCashForFixedIncome = mess.unusedUnsettledNegativeCashForFixedIncome;
        }
        if (!isNullOrUndefined(mess.usedUnsettledNegativeCashForFixedIncome)) {
            assetBalanceData.usedUnsettledNegativeCashForFixedIncome = mess.usedUnsettledNegativeCashForFixedIncome;
        }
        if (!isNullOrUndefined(mess.unsettledPositiveCashForFixedIncome)) {
            assetBalanceData.unsettledPositiveCashForFixedIncome = mess.unsettledPositiveCashForFixedIncome;
        }
        if (!isNullOrUndefined(mess.withdrawableCashForFixedIncome)) {
            assetBalanceData.withdrawableCashForFixedIncome = mess.withdrawableCashForFixedIncome;
        }
        if (!isNullOrUndefined(mess.unusedUnsettledNegativeAccruedInterest)) {
            assetBalanceData.unusedUnsettledNegativeAccruedInterest = mess.unusedUnsettledNegativeAccruedInterest;
        }
        if (!isNullOrUndefined(mess.usedUnsettledNegativeAccruedInterest)) {
            assetBalanceData.usedUnsettledNegativeAccruedInterest = mess.usedUnsettledNegativeAccruedInterest;
        }
        if (!isNullOrUndefined(mess.unsettledPositiveAccruedInterest)) {
            assetBalanceData.unsettledPositiveAccruedInterest = mess.unsettledPositiveAccruedInterest;
        }
        if (!isNullOrUndefined(mess.projectedBalance)) {
            assetBalanceData.projectedBalance = mess.projectedBalance;
        }
        if (!isNullOrUndefined(mess.positionValues)) {
            this.updatePositionValues(mess.positionValues);
        }
        if (isValidNumber(mess.currentVolumeLimit)) {
            assetBalanceData.currentVolumeLimit = mess.currentVolumeLimit;
        }
        if (isValidNumber(mess.relativeVolumeLimit)) {
            assetBalanceData.relativeVolumeLimit = mess.relativeVolumeLimit;
        }
        if (!isNullOrUndefined(mess.instrumentVolumeLimits)) {
            assetBalanceData.instrumentVolumeLimits = mess.instrumentVolumeLimits;
        }
        return AssetAdditionalInfoUpdated;
    }
    get TodayRealizedPNL() {
        const assetBalanceData = this.assetBalanceData;
        return isNaN(assetBalanceData.realizedPnl)
            ? assetBalanceData.balance - assetBalanceData.beginBalance
            : assetBalanceData.realizedPnl;
    }
    get TodayRealizedPNLCrossPrice() {
        return this.TodayRealizedPNL * this.getCrossPrice();
    }
    get TodayFees() {
        return this.assetBalanceData.todayFees;
    }
    get TodayFeesCrossPrice() {
        return this.assetBalanceData.todayFees * this.getCrossPrice();
    }
    get TodayGrossPNL() {
        return this.assetBalanceData.realizedPnl - this.assetBalanceData.todayFees - this.assetBalanceData.todaySwaps;
    }
    get TodayGrossPNLCrossPrice() {
        return this.TodayGrossPNL * this.getCrossPrice();
    }
    get TodayVolume() {
        return this.assetBalanceData.todayVolume;
    }
    get TodayTrades() {
        return this.assetBalanceData.todayTrades;
    }
    get TodayRebates() {
        return this.assetBalanceData.todayRebates;
    }
    get TodayRebatesCrossPrice() {
        return this.assetBalanceData.todayRebates * this.getCrossPrice();
    }
    get WithdrawForAccount() {
        if (this.assetBalanceData.blockedSum < Number.MAX_VALUE &&
            this.assetBalanceData.blockedSum > Number.MIN_VALUE) {
            return this.assetBalanceData.blockedSum;
        }
        else {
            return 0;
        }
    }
    get BalanceCrossPrice() {
        return this.assetBalanceData.balance * this.getCrossPrice();
    }
    get BlockedSumCrossPrice() {
        return this.assetBalanceData.blockedSum * this.getCrossPrice();
    }
    get MinMarginCrossPrice() {
        return this.assetBalanceData.minMargin * this.getCrossPrice();
    }
    get MarginAvailableCrossPrice() {
        return this.assetBalanceData.availableMargin * this.getCrossPrice();
    }
    get MaintMarginForPositionCrossPrice() {
        return this.assetBalanceData.maintanceMargin * this.getCrossPrice();
    }
    get BlockedForOrdersCrossPrice() {
        return this.assetBalanceData.blockedForOrders * this.getCrossPrice();
    }
    get CreditValueCrossPrice() {
        return this.assetBalanceData.creditValue * this.getCrossPrice();
    }
    get MarginDeficiencyCrossPrice() {
        return this.assetBalanceData.marginDeficiency * this.getCrossPrice();
    }
    get MarginSurplusCrossPrice() {
        return this.assetBalanceData.marginSurplus * this.getCrossPrice();
    }
    get TodaySwapsCrossPrice() {
        return this.assetBalanceData.todaySwaps * this.getCrossPrice();
    }
    get AssetAdditionalInfo() {
        return this.assetBalanceData.AssetAdditionalInfo;
    }
    // #region Server data
    get AvailableMargin() {
        return this.assetBalanceData.availableMargin;
    }
    set AvailableMargin(value) {
        this.assetBalanceData.availableMargin = value;
    }
    get AvailableFunds() {
        return this.assetBalanceData.availableFunds;
    }
    set AvailableFunds(value) {
        this.assetBalanceData.availableFunds = value;
    }
    get StocksLiquidity() {
        return this.assetBalanceData.StocksLiquidity;
    }
    set StocksLiquidity(value) {
        this.assetBalanceData.StocksLiquidity = value;
    }
    get BalancePlusAllRisks() {
        return this.Balance;
    }
    get Balance() {
        return this.assetBalanceData.balance;
    }
    set Balance(value) {
        this.assetBalanceData.balance = value;
    }
    get BeginBalance() {
        return this.assetBalanceData.beginBalance;
    }
    set BeginBalance(value) {
        this.assetBalanceData.beginBalance = value;
    }
    get BlockedForOrders() {
        return this.assetBalanceData.blockedForOrders;
    }
    set BlockedForOrders(value) {
        this.assetBalanceData.blockedForOrders = value;
    }
    get BlockedSum() {
        return this.assetBalanceData.blockedSum;
    }
    set BlockedSum(value) {
        this.assetBalanceData.blockedSum = value;
    }
    get CashBalance() {
        return this.assetBalanceData.cashBalance;
    }
    set CashBalance(value) {
        this.assetBalanceData.cashBalance = value;
    }
    get CreditValue() {
        return this.assetBalanceData.creditValue;
    }
    set CreditValue(value) {
        this.assetBalanceData.creditValue = value;
    }
    get RealizedPnl() {
        return this.assetBalanceData.realizedPnl;
    }
    set RealizedPnl(value) {
        this.assetBalanceData.realizedPnl = value;
    }
    get MaintanceMargin() {
        return this.assetBalanceData.maintanceMargin;
    }
    set MaintanceMargin(value) {
        this.assetBalanceData.maintanceMargin = value;
    }
    get MarginDeficiency() {
        return this.assetBalanceData.marginDeficiency;
    }
    set MarginDeficiency(value) {
        this.assetBalanceData.marginDeficiency = value;
    }
    get MarginSurplus() {
        return this.assetBalanceData.marginSurplus;
    }
    set MarginSurplus(value) {
        this.assetBalanceData.marginSurplus = value;
    }
    get ReservedBalance() {
        return this.assetBalanceData.reservedBalance;
    }
    set ReservedBalance(value) {
        this.assetBalanceData.reservedBalance = value;
    }
    get TodayTurnover() {
        return this.assetBalanceData.todayTurnover;
    }
    set TodayTurnover(value) {
        this.assetBalanceData.todayTurnover = value;
    }
    get MinMargin() {
        return this.assetBalanceData.minMargin;
    }
    set MinMargin(value) {
        this.assetBalanceData.minMargin = value;
    }
    get TodaySwaps() {
        return this.assetBalanceData.todaySwaps;
    }
    get UnsettledProfit() {
        return this.assetBalanceData.unsettledProfit;
    }
    set UnsettledProfit(value) {
        this.assetBalanceData.unsettledProfit = value;
    }
    get UnsettledLoss() {
        return this.assetBalanceData.unsettledLoss;
    }
    set UnsettledLoss(value) {
        this.assetBalanceData.unsettledLoss = value;
    }
    get UnsettledLossAvailableForWithdrawal() {
        return this.assetBalanceData.UnsettledLossAvailableForWithdrawal;
    }
    set UnsettledLossAvailableForWithdrawal(value) {
        this.assetBalanceData.UnsettledLossAvailableForWithdrawal = value;
    }
    get UnusedSettledCashForStocks() {
        return this.assetBalanceData.UnusedSettledCashForStocks;
    }
    set UnusedSettledCashForStocks(value) {
        this.assetBalanceData.UnusedSettledCashForStocks = value;
    }
    get UnsettledDeposit() {
        return this.assetBalanceData.unsettledDeposit;
    }
    set UnsettledDeposit(value) {
        this.assetBalanceData.unsettledDeposit = value;
    }
    get UnusedSettledCollateral() {
        return this.assetBalanceData.UnusedSettledCollateral;
    }
    set UnusedSettledCollateral(value) {
        this.assetBalanceData.UnusedSettledCollateral = value;
    }
    /// <summary>
    /// #98625
    /// </summary>
    get UnusedIntradayInitialMargin() {
        return this.assetBalanceData.UnusedIntradayInitialMargin;
    }
    set UnusedIntradayInitialMargin(value) {
        this.assetBalanceData.UnusedIntradayInitialMargin = value;
    }
    get UsedOvernightInitialMarginForIntraday() {
        return this.assetBalanceData.UsedOvernightInitialMarginForIntraday;
    }
    set UsedOvernightInitialMarginForIntraday(value) {
        this.assetBalanceData.UsedOvernightInitialMarginForIntraday = value;
    }
    get AccruedDividends() {
        return this.assetBalanceData.AccruedDividends;
    }
    set AccruedDividends(value) {
        this.assetBalanceData.AccruedDividends = value;
    }
    /// <summary>
    /// #75187
    /// </summary>
    get WithdrawableCashForStocks() {
        return this.assetBalanceData.WithdrawableCashForStocks;
    }
    set WithdrawableCashForStocks(value) {
        this.assetBalanceData.WithdrawableCashForStocks = value;
    }
    /// <summary>
    /// #75187
    /// </summary>
    get WithdrawableUnsettledPnL() {
        return this.assetBalanceData.WithdrawableUnsettledPnL;
    }
    set WithdrawableUnsettledPnL(value) {
        this.assetBalanceData.WithdrawableUnsettledPnL = value;
    }
    get TrailingDrawdownLevel() {
        return this.assetBalanceData.trailingDrawdownLevel;
    }
    set TrailingDrawdownLevel(value) {
        this.assetBalanceData.trailingDrawdownLevel = value;
    }
    /// <summary>
    /// #59262
    /// </summary>
    get StockOrdersReq() {
        return this.assetBalanceData.stockOrdersReq;
    }
    set StockOrdersReq(value) {
        this.assetBalanceData.stockOrdersReq = value;
    }
    get CurrentDailyLoss() {
        return this.assetBalanceData.currentDailyLoss;
    }
    set CurrentDailyLoss(value) {
        this.assetBalanceData.currentDailyLoss = value;
    }
    get CurrentDailyProfit() {
        return this.assetBalanceData.currentDailyProfit;
    }
    set CurrentDailyProfit(value) {
        this.assetBalanceData.currentDailyProfit = value;
    }
    get CurrentWeeklyLoss() {
        return this.assetBalanceData.currentWeeklyLoss;
    }
    set CurrentWeeklyLoss(value) {
        this.assetBalanceData.currentWeeklyLoss = value;
    }
    get UsedUnsettledNegativePremium() {
        return this.assetBalanceData.UsedUnsettledNegativePremium;
    }
    set UsedUnsettledNegativePremium(value) {
        this.assetBalanceData.UsedUnsettledNegativePremium = value;
    }
    get UnusedUnsettledNegativePremium() {
        return this.assetBalanceData.UnusedUnsettledNegativePremium;
    }
    set UnusedUnsettledNegativePremium(value) {
        this.assetBalanceData.UnusedUnsettledNegativePremium = value;
    }
    get UnsettledPositivePremium() {
        return this.assetBalanceData.UnsettledPositivePremium;
    }
    set UnsettledPositivePremium(value) {
        this.assetBalanceData.UnsettledPositivePremium = value;
    }
    get UnsettledPremiumFromOpenSell() {
        return this.assetBalanceData.UnsettledPremiumFromOpenSell;
    }
    set UnsettledPremiumFromOpenSell(value) {
        this.assetBalanceData.UnsettledPremiumFromOpenSell = value;
    }
    get UsedPremiumFromOpenSell() {
        return this.assetBalanceData.UsedPremiumFromOpenSell;
    }
    set UsedPremiumFromOpenSell(value) {
        this.assetBalanceData.UsedPremiumFromOpenSell = value;
    }
    get UnusedPremiumFromOpenSell() {
        return this.assetBalanceData.UnusedPremiumFromOpenSell;
    }
    set UnusedPremiumFromOpenSell(value) {
        this.assetBalanceData.UnusedPremiumFromOpenSell = value;
    }
    get UsedUnsettledNegativeCashForStocks() {
        return this.assetBalanceData.UsedUnsettledNegativeCashForStocks;
    }
    set UsedUnsettledNegativeCashForStocks(value) {
        this.assetBalanceData.UsedUnsettledNegativeCashForStocks = value;
    }
    get UnusedUnsettledNegativeCashForStocks() {
        return this.assetBalanceData.UnusedUnsettledNegativeCashForStocks;
    }
    set UnusedUnsettledNegativeCashForStocks(value) {
        this.assetBalanceData.UnusedUnsettledNegativeCashForStocks = value;
    }
    get UnsettledPositiveCashForStocks() {
        return this.assetBalanceData.UnsettledPositiveCashForStocks;
    }
    set UnsettledPositiveCashForStocks(value) {
        this.assetBalanceData.UnsettledPositiveCashForStocks = value;
    }
    get OptionPremiumReq() {
        return this.assetBalanceData.OptionPremiumReq;
    }
    set OptionPremiumReq(value) {
        this.assetBalanceData.OptionPremiumReq = value;
    }
    /// <summary>
    /// #82716
    /// </summary>
    get UnsettledCollateral() {
        return this.assetBalanceData.UnsettledCollateral;
    }
    set UnsettledCollateral(value) {
        this.assetBalanceData.UnsettledCollateral = value;
    }
    /// <summary>
    /// #82716
    /// </summary>
    get WithdrawableUnsettledCollateral() {
        return this.assetBalanceData.WithdrawableUnsettledCollateral;
    }
    set WithdrawableUnsettledCollateral(value) {
        this.assetBalanceData.WithdrawableUnsettledCollateral = value;
    }
    /// <summary>
    /// #82716
    /// </summary>
    get Collateral() {
        return this.assetBalanceData.Collateral;
    }
    set Collateral(value) {
        this.assetBalanceData.Collateral = value;
    }
    /// <summary>
    /// #91468
    /// </summary>
    get WarningMarginRequirement() {
        return this.assetBalanceData.warningMarginRequirement;
    }
    get MarginBeforeWarning() {
        return this.assetBalanceData.marginBeforeWarning;
    }
    /// <summary>
    /// #110792
    /// </summary>
    get WithdrawalAvailable() {
        return this.assetBalanceData.WithdrawalAvailable;
    }
    set WithdrawalAvailable(value) {
        this.assetBalanceData.WithdrawalAvailable = value;
    }
    // #endregion
    get MaintenanceMarginReqPercent() {
        return this.assetBalanceData.MaintenanceMarginReqPercent;
    }
    get InitialMarginReqPercent() {
        return this.assetBalanceData.InitialMarginReqPercent;
    }
    get WarningMarginReqPercent() {
        return this.assetBalanceData.WarningMarginReqPercent;
    }
    get StopOutValue() {
        return this.assetBalanceData.StopOutValue;
    }
    get EODTrailingDrawdownLevel() {
        return this.assetBalanceData.EODTrailingDrawdownLevel;
    }
    // #120451
    get CalculatedRelativeDailyLossLimit() {
        return this.assetBalanceData.CalculatedRelativeDailyLossLimit;
    }
    get RelativeOfRelativeDailyLossLimit() {
        return this.assetBalanceData.RelativeOfRelativeDailyLossLimit;
    }
    get WithdrawableOptionsPremium() {
        return this.assetBalanceData.WithdrawableOptionsPremium;
    }
    set WithdrawableOptionsPremium(value) {
        this.assetBalanceData.WithdrawableOptionsPremium = value;
    }
    get BuyingPowerAvailableFunds() {
        return this.assetBalanceData.BuyingPowerAvailableFunds;
    }
    set BuyingPowerAvailableFunds(value) {
        this.assetBalanceData.BuyingPowerAvailableFunds = value;
    }
    get AvailableCash() {
        return this.assetBalanceData.AvailableCash;
    }
    set AvailableCash(value) {
        this.assetBalanceData.AvailableCash = value;
    }
    get TotalPositionsValue() {
        return this.assetBalanceData.TotalPositionsValue;
    }
    set TotalPositionsValue(value) {
        this.assetBalanceData.TotalPositionsValue = value;
    }
    get BlockedForFixedIncome() {
        return this.assetBalanceData.blockedForFixedIncome;
    }
    get FixedIncomeOrdersReq() {
        return this.assetBalanceData.fixedIncomeOrdersReq;
    }
    get UnusedUnsettledNegativeCashForFixedIncome() {
        return this.assetBalanceData.unusedUnsettledNegativeCashForFixedIncome;
    }
    get UsedUnsettledNegativeCashForFixedIncome() {
        return this.assetBalanceData.usedUnsettledNegativeCashForFixedIncome;
    }
    get UnsettledPositiveCashForFixedIncome() {
        return this.assetBalanceData.unsettledPositiveCashForFixedIncome;
    }
    get WithdrawableCashForFixedIncome() {
        return this.assetBalanceData.withdrawableCashForFixedIncome;
    }
    get UnusedUnsettledNegativeAccruedInterest() {
        return this.assetBalanceData.unusedUnsettledNegativeAccruedInterest;
    }
    get UsedUnsettledNegativeAccruedInterest() {
        return this.assetBalanceData.usedUnsettledNegativeAccruedInterest;
    }
    get UnsettledPositiveAccruedInterest() {
        return this.assetBalanceData.unsettledPositiveAccruedInterest;
    }
    getPositionValue(routeId, instrumentGroupId, productType) {
        return this.assetBalanceData.positionValues.find((p) => p.routeId === routeId && p.instrumentTypeId === instrumentGroupId && p.productType === productType);
    }
    getAssetInstrumentVolumeLimit(instrumentType) {
        if (instrumentType === InstrumentTypes.ALL) {
            return {
                instrumentType: InstrumentTypes.ALL,
                currentVolumeLimit: this.assetBalanceData.currentVolumeLimit,
                relativeVolumeLimit: this.assetBalanceData.relativeVolumeLimit
            };
        }
        return this.assetBalanceData.instrumentVolumeLimits.find((p) => p.instrumentType === instrumentType);
    }
    getCrossPrice() {
        return this.Asset ? this.FDataCache.CrossRateCache.GetCrossPriceExp1(this.Asset.Name, this.account) : 1;
    }
    formatPriceExactly(value, noCurrency = false) {
        return this.Asset.formatPrice(value, noCurrency);
    }
    formatPrice(value, noCurrency = false) {
        return this.Asset.formatPrice(value, noCurrency);
    }
    roundFormatPrice(value, noCurrency = false) {
        return this.Asset.roundFormatPrice(value, noCurrency);
    }
    WithdrawalAvailableTruncateToAsset(val) {
        return MathUtils.TruncateDouble(Math.max(val, 0), this.Asset.Point);
    }
    WithdrawalAvaliable(acc) {
        const valueFromServer = this.WithdrawalAvailable; // #110792
        return valueFromServer !== null
            ? this.WithdrawalAvailableTruncateToAsset(valueFromServer)
            : this.AvaliableWithdrawCalculate(acc);
    }
    AvaliableWithdrawCalculate(acc) {
        try {
            let stockValueDiscount = 0;
            if (acc != null && acc.AccountType !== AccountType.MultiAsset) {
                stockValueDiscount = acc.StockValueDiscount;
            }
            // ++64321
            const creditValue = this.CreditValue > 0 ? this.CreditValue : 0;
            const withdrawalAvailable = this.AvailableFunds -
                stockValueDiscount -
                creditValue -
                acc.OnlyProfitForWithdrawalAvailable -
                this.UnsettledProfit -
                this.UnsettledLossAvailableForWithdrawal +
                this.UnusedUnsettledNegativeCashForStocks -
                this.UnsettledPositiveCashForStocks +
                this.UnusedUnsettledNegativePremium -
                this.UnsettledPositivePremium +
                this.UnsettledPremiumFromOpenSell -
                this.UsedPremiumFromOpenSell +
                this.WithdrawableCashForStocks +
                this.WithdrawableUnsettledPnL +
                this.WithdrawableUnsettledCollateral -
                this.StocksLiquidity +
                this.UnusedIntradayInitialMargin -
                this.UsedOvernightInitialMarginForIntraday -
                this.AccruedDividends +
                this.WithdrawableOptionsPremium -
                this.UnsettledDeposit +
                this.UnusedUnsettledNegativeCashForFixedIncome -
                this.UnsettledPositiveCashForFixedIncome +
                this.WithdrawableCashForFixedIncome +
                this.UnusedUnsettledNegativeAccruedInterest -
                this.UnsettledPositiveAccruedInterest;
            return this.WithdrawalAvailableTruncateToAsset(withdrawalAvailable);
        }
        catch (ex) {
            ErrorInformationStorage.GetException(ex);
            return 0;
        }
    }
    updatePositionValues(positionValues) {
        for (let i = 0; i < positionValues.length; i++) {
            const newPositionValue = positionValues[i];
            const oldPositionValue = this.getPositionValue(newPositionValue.routeId, newPositionValue.instrumentTypeId, newPositionValue.productType);
            if (!isNullOrUndefined(oldPositionValue)) {
                const index = this.assetBalanceData.positionValues.indexOf(oldPositionValue);
                if (newPositionValue.isRemoved) {
                    this.assetBalanceData.positionValues.splice(index, 1);
                }
                else {
                    this.assetBalanceData.positionValues[index] = newPositionValue;
                }
            }
            else {
                this.assetBalanceData.positionValues.push(newPositionValue);
            }
        }
    }
}
// #region AssetBalanceData
export class AssetBalanceData {
    constructor() {
        this.availableMargin = 0;
        this.availableFunds = 0;
        this.balance = 0;
        this.beginBalance = 0;
        this.blockedForOrders = 0;
        // public blockedForPAMM = 0
        this.blockedForStocks = 0;
        this.blockedSum = 0;
        this.cashBalance = 0;
        this.creditValue = 0;
        this.realizedPnl = 0;
        this.maintanceMargin = 0;
        this.warningMarginRequirement = 0;
        this.marginBeforeWarning = 0;
        this.marginDeficiency = 0;
        this.marginSurplus = 0;
        this.projectedBalance = 0;
        this.reservedBalance = 0;
        this.todayFees = 0;
        this.todayTurnover = 0;
        this.minMargin = 0;
        this.todayTrades = 0;
        this.todayVolume = 0;
        this.todayRebates = 0;
        this.todaySwaps = 0;
        this.unsettledProfit = 0;
        this.unsettledLoss = 0;
        this.unsettledDeposit = 0;
        this.UnsettledLossAvailableForWithdrawal = 0;
        this.currentDailyLoss = 0;
        this.currentDailyProfit = 0;
        this.currentWeeklyLoss = 0;
        this.trailingDrawdownLevel = -1;
        this.stockOrdersReq = 0;
        this.UsedUnsettledNegativePremium = 0;
        this.UnusedUnsettledNegativePremium = 0;
        this.UnsettledPositivePremium = 0;
        this.UnsettledPremiumFromOpenSell = 0;
        this.UsedPremiumFromOpenSell = 0;
        this.UnusedPremiumFromOpenSell = 0;
        this.UsedUnsettledNegativeCashForStocks = 0;
        this.UnusedUnsettledNegativeCashForStocks = 0;
        this.UnsettledPositiveCashForStocks = 0;
        this.StocksLiquidity = 0;
        this.OptionPremiumReq = 0;
        this.WithdrawableCashForStocks = 0;
        this.WithdrawableUnsettledPnL = 0;
        // 82717
        this.UnsettledCollateral = 0;
        this.WithdrawableUnsettledCollateral = 0;
        this.Collateral = 0;
        this.InitialMarginWithoutWaived = 0;
        // 98161
        this.UnusedSettledCashForStocks = 0;
        this.UnusedSettledCollateral = 0;
        this.UnsettledDeposit = 0;
        // 98625
        this.UnusedIntradayInitialMargin = 0;
        this.UsedOvernightInitialMarginForIntraday = 0;
        this.AccruedDividends = 0;
        this.AssetAdditionalInfo = {};
        this.WithdrawableOptionsPremium = 0;
        this.WithdrawalAvailable = null;
        this.BuyingPowerAvailableFunds = null; // array of BuyingPowerAvailableFund
        // 119981
        this.MaintenanceMarginReqPercent = null;
        this.InitialMarginReqPercent = null;
        this.WarningMarginReqPercent = null;
        this.StopOutValue = null;
        this.EODTrailingDrawdownLevel = null;
        // #120451
        this.CalculatedRelativeDailyLossLimit = null;
        this.RelativeOfRelativeDailyLossLimit = null;
        this.CurrentDailyProfit = null;
        this.AvailableCash = null;
        this.TotalPositionsValue = null;
        this.blockedForFixedIncome = 0;
        this.fixedIncomeOrdersReq = 0;
        this.unusedUnsettledNegativeCashForFixedIncome = 0;
        this.usedUnsettledNegativeCashForFixedIncome = 0;
        this.unsettledPositiveCashForFixedIncome = 0;
        this.withdrawableCashForFixedIncome = 0;
        this.unusedUnsettledNegativeAccruedInterest = 0;
        this.usedUnsettledNegativeAccruedInterest = 0;
        this.unsettledPositiveAccruedInterest = 0;
        this.positionValues = [];
        this.currentVolumeLimit = 0;
        this.relativeVolumeLimit = 0;
        this.instrumentVolumeLimits = [];
    }
}
AssetBalanceData.Empty = new AssetBalanceData();
